import { articles, type Article } from '@/mocks/articles';
import { categories, type Category } from '@/mocks/categories';

export const allArticles: Article[] = [...articles].sort(
  (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
);

export function getArticleById(id: string): Article | undefined {
  return articles.find((item) => item.id === id);
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getCategoryName(slug: string): string {
  return getCategoryBySlug(slug)?.name ?? '观察';
}

export function getArticlesByCategory(slug: string): Article[] {
  return allArticles.filter((item) => item.categorySlug === slug);
}

export function getCategoryCount(slug: string): number {
  return getArticlesByCategory(slug).length;
}

export function getFeaturedArticles(limit = 3): Article[] {
  const featured = allArticles.filter((item) => item.featured);
  return (featured.length >= limit ? featured : allArticles).slice(0, limit);
}

export function getRelatedArticles(current: Article, limit = 3): Article[] {
  const sameCategory = allArticles.filter(
    (item) => item.id !== current.id && item.categorySlug === current.categorySlug,
  );
  const others = allArticles.filter(
    (item) => item.id !== current.id && item.categorySlug !== current.categorySlug,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function filterArticles(options: { keyword?: string; category?: string; sort?: string }): Article[] {
  const keyword = (options.keyword ?? '').trim().toLowerCase();
  const category = options.category ?? 'all';
  const sort = options.sort ?? 'latest';

  let list = allArticles.filter((item) => {
    const matchCategory = category === 'all' || item.categorySlug === category;
    if (!matchCategory) return false;
    if (!keyword) return true;
    const haystack = [item.title, item.excerpt, getCategoryName(item.categorySlug), ...item.tags]
      .join(' ')
      .toLowerCase();
    return haystack.includes(keyword);
  });

  list = [...list].sort((a, b) => {
    if (sort === 'hot') return b.views - a.views;
    return new Date(b.date).getTime() - new Date(a.date).getTime();
  });

  return list;
}

export function formatDate(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  return `${date.getFullYear()}年${date.getMonth() + 1}月${date.getDate()}日`;
}